const API = {
  AUTH: {
    LOGIN: '/sts/login',
    LOGOUT: '/auth/logout',
    FORGET_PASSWORD: '/auth/forget-password',
    POST_UPDATE_PASSWORD: 'auth/updatePassword',
    POST_RESET_PASSWORD: 'auth/password/reset',
    GET_DOMAIN_CONFIG: '/sts/domain-config',
    UPDATE_THEME: '/sts/update/domain-theme',
  },

  USER: {
    GET_ACCOUNT: 'auth/account',
    GET_NAVIGATION: '/auth/navigate',
    GET_PROJECTS: '/sts/users',
    GET_USER_DETAILS: '/sts/user/get-user-details',
    ADD_MAIL_RECEIVER: '/sts/user/add-mail-receiver',
    GET_PROJECT_IDS: '/sts/get-project-ids',
    GET_USER_GROUPS: '/sts/userGroup',
  },
  LISTBOX: {
    GET_LIST: '/flexq/list-box',
  },
  PROJECT_MANAGEMENT: {
    FLEXQ_DELETE_TASK: '/sts/deleteTask',
    FLEXQ_GET_TASK: '/sts/getTask',
    FLEXQ_SAVE_TASK: 'sts/saveTask',
    FLEXQ_UPDATE_TASK: 'sts/updateTask',
    FLEXQ_UPDATE_MULTIPLE_TASK: 'sts/updateMultipleTask',
    FILE_UPLOAD: '/sts/taskFilesUpload',
    GET_FILES: '/sts/getTaskFiles',
    GET_COMMENTS: '/sts/getTaskComments',
    SAVE_COMMENT: '/sts/saveComments',
    GET_COMMENT_FILES: '/sts/getCommentAttachments',
    GET_ALL_GROUPS: '/sts/getAllGroups',
    GET_ALL_SCREENS: '/sts/getAllScreens',
    GET_EXPORT_DATA: '/sts/getTaskExportData',
    GET_TEAM_BY_USER: '/sts/getUserAssigneeGroup',
    GET_TEAMS_BY_USERS: '/sts/getMultipleUserAssigneeGroup',
    BULK_TASK_UPLOAD: '/sts/save-bulk-task',
    // `${TASK_REQUEST}/<taskId>/mr`: GET lists, POST adds, DELETE removes merge request links
    TASK_REQUEST: '/sts/task-request',
  },
  TIMESHEET_LOGS: {
    GET_ALL: '/sts/getTimeSheetLogs',
    SAVE: '/sts/saveTimeSheetLog',
    UPDATE: '/sts/updateTimeSheetLog',
    MULTIPLE_UPDATE: '/sts/updateMultipleTimeSheetLogs',
    DELETE: '/sts/deleteTimesheetLog',
  },
  TEST_STATUS: {
    GET_ALL: '/sts/getTestStatus',
    SAVE: '/sts/saveTestStatus',
    UPDATE: '/sts/updateTestStatus',
    DELETE: '/sts/deleteTestStatus',
  },
  COMMUNICATION_TRACKING: {
    GET_ALL: '/sts/getAllInternalDiscussionForum',
    SAVE: '/sts/saveInternalDiscussionForum',
    UPDATE: '/sts/updateInternalDiscussionForum',
    DELETE: '/sts/deleteInternalDiscussionForum',
  },
  FLEXQ: {
    FLEXQ_SEARCH: '/flexq/search',
    FLEXQ_TEMPLATE: '/flexq/template',
    FLEXQ_CRUD: '/flexq/template-crud',
    FLEXQ_COLUMNS: '/flexq/columns',
  },
  STS_UTILITY: {
    GET_TEAMS: '/sts/getStsTeams',
    GET_CATEGORIES: '/sts/getCategoriesByProjectId',
    GET_TAGS: '/sts/getTagsByProjectId',
    GET_STATUS: '/sts/getStatusByProjectId',
    DELETE_TASK_FILES: '/sts/deleteTaskFiles',
  },
  PREFERENCE: {
    GET_PREFERENCE: '/auth/user/preference/get',
  },
};
export default API;
